module.exports = __webpack_public_path__ + "static/media/galleryGT (4).3fbbd7a4.jpg";